'use client';
import LedgerViewer from './components/LedgerViewer';

export default function LedgerViewerPage() {
  return <LedgerViewer />;
}
